import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PartnerDealCommitteeQueueVoterResponse } from '@interfaces/partners/responses/partner-deal-committee.response';
import { TooltipModule } from 'primeng/tooltip';
import {
  describeVoterVote,
  voterInitials,
  voterTone,
} from '@app/features/dashboard/commercial/pages/credit-committee/credit-committee-presenter';

/**
 * Placar de uma rodada do comitê (card 3789): um selo por votante, com as iniciais e a cor do voto
 * (verde aprovou, vermelho negou, âmbar contestou, cinza ainda não votou). O texto inteiro aparece ao
 * passar o mouse e é o que o leitor de tela lê, então a cor nunca é o único sinal.
 */
@Component({
  selector: 'app-committee-voter-badges',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './committee-voter-badges.component.html',
  styleUrl: './committee-voter-badges.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommitteeVoterBadgesComponent {
  readonly voters = input.required<PartnerDealCommitteeQueueVoterResponse[]>();

  protected readonly initials = voterInitials;
  protected readonly tone = voterTone;
  protected readonly describe = describeVoterVote;
}
